import { ComponentProps } from 'react';
import { DateValue } from 'react-aria';
import { FormattedDate } from 'react-intl';

import isSameDate from '../../helpers/date/isSameDate';
import Text from '../Text/Text';

type DatePeriodProps = {
    start?: DateValue;
    end?: DateValue;
    timeZone: string;
    hideYear?: boolean;
} & ComponentProps<typeof Text>;

const DatePeriod = ({
    start,
    end,
    timeZone,
    hideYear,
    ...textProps
}: DatePeriodProps) => {
    if (start && end && isSameDate(start, end)) {
        return (
            <Text {...textProps}>
                <FormattedDate
                    value={start.toDate(timeZone)}
                    day="numeric"
                    month="long"
                    year={hideYear ? undefined : 'numeric'}
                    timeZone={timeZone}
                />
            </Text>
        );
    }

    return (
        <Text {...textProps}>
            {start ? (
                <FormattedDate
                    value={start.toDate(timeZone)}
                    day="numeric"
                    month="short"
                    year={hideYear ? undefined : 'numeric'}
                    timeZone={timeZone}
                />
            ) : (
                '∞'
            )}

            {' - '}

            {end ? (
                <FormattedDate
                    value={end.toDate(timeZone)}
                    day="numeric"
                    month="short"
                    year={hideYear ? undefined : 'numeric'}
                    timeZone={timeZone}
                />
            ) : (
                '∞'
            )}
        </Text>
    );
};

export default DatePeriod;
